import AdvertisingReport from "./ad_report/AdvertisingReport";
import Exports from "./Exports";
import SearchTermReport from "views/SearchTermReport";
import OrgReport from "views/OrgReport";
import type { RouteDefinition } from "../../routes/routes";
import ProductReport from "./product_report/ProductReport";
import PricingPlanReport from "./pricing_plan/PricingPlanReport";
import TargetReport from "./target_report/TargetReport";
import SearchQueryPerformanceDashboard from "modules/sqpr/SearchQueryPerformanceDashboard";

export const ReportRoutes: RouteDefinition[] = [
  {
    path: "/report/advertisement",
    layout: "/user",
    component: AdvertisingReport,
    application: "Reports",
  },
  {
    path: "/report/product",
    layout: "/user",
    component: ProductReport,
    application: "Reports",
  },
  {
    path: "/report/pricing_plan",
    layout: "/user",
    component: PricingPlanReport,
    application: "Reports",
  },
  {
    path: "/report/search_term_report",
    layout: "/user",
    component: SearchTermReport,
    application: "Reports",
  },
  {
    path: "/report/export",
    layout: "/user",
    component: Exports,
    application: "Reports",
  },
  {
    path: "/report/organization/summary",
    layout: "/user",
    component: OrgReport,
    application: "Reports",
  },
  {
    path: "/report/organization/summary",
    layout: "/pdf",
    component: OrgReport,
    application: "Reports",
  },
  {
    path: "/report/target",
    layout: "/user",
    component: TargetReport,
    application: "Reports",
  },
  {
    path: "/report/sqpr_report",
    layout: "/user",
    component: SearchQueryPerformanceDashboard,
    application: "Reports",
  },
];
